import { ReactNode } from 'react';

type props = {
  children: ReactNode;
  icon: ReactNode;
};
export const IconBox = ({ children, icon }: props) => {
  if (!icon) {
    return children;
  }
  return (
    <div style={{ position: 'relative' }}>
      <div style={{ position: 'absolute', top: 0, right: 0 }}>{icon}</div>
      {children}
    </div>
  );
};
